
import { defineComponent } from '@nuxtjs/composition-api';
import MobileAppBannerMixin from '@/components/partials/war-room/WarRoomMobileAppBanner/mobileAppBannerMixin';

const TOOLTIP_NAME = 'mobile-app-banner-aside';

export default defineComponent({
  name: 'WarRoomMobileAppBannerAside',
  mixins: [MobileAppBannerMixin(TOOLTIP_NAME)],
});
